module.exports = __webpack_public_path__ + "static/media/hp-f-3-b-7853421-fb-3-deb-442-a-85142939-c-66-edf-6-ab-5-bd.fd97c6b6.jpg";